import { Navbar } from 'react-bootstrap';

const NavigationBar = ({ title, imageName = "white-duke.jpg" }) => (
    <Navbar variant="dark" className="navbarStyle">
        <a className="navbar-brand" href="https://www.duke-energy.com/home">
            <img 
                src={`/assets/images/${imageName}`}
                alt="Duke Energy Logo"
                width={150} />
        </a>
        <span className="line"></span>
        <h4 className="program-title">{title}</h4>
    </Navbar>
);

export default NavigationBar;